import { createElement, type ComponentType } from 'react';
import { useParams, useSearchParams } from 'react-router';
import { EmptyState } from '@/ui';
import { Page } from './components';
import { validId } from './domain';
import { useWords } from './hooks';

/** Validate route input before it can become an authenticated resource path. */
export function AgentRouteGate({screen}:{screen:ComponentType}){
 const params=useParams();const [query]=useSearchParams();const {w}=useWords();
 const ids=['accountId','assistantId','conversationId','itemId','documentId','draftId','proposalId','approvalId','connectionId'];
 const invalid=ids.some(key=>params[key]!==undefined&&!validId(params[key]))
  ||['conversationId','assistantId','agent_id'].some(key=>query.has(key)&&!validId(query.get(key)))
  ||params.runId!==undefined&&!/^tr_[A-Za-z0-9_-]{1,80}$/u.test(params.runId)
  ||params.turn!==undefined&&(!/^\d+$/u.test(params.turn)||Number(params.turn)>2147483647)
  ||params.call!==undefined&&(!/^\d+$/u.test(params.call)||Number(params.call)<1||Number(params.call)>100000);
 return invalid?<Page title={w('Agents')}><EmptyState title={w('This is no longer available.')}/></Page>:createElement(screen);
}
